/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useState } from 'react';
import { DataAPIClientError } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';
import { ContactMappingEntity } from './types';

interface State {
  readonly data?: ContactMappingEntity[];
  readonly error?: DataAPIClientError;
  readonly isLoading: boolean;
}

interface Result extends State {
  readonly refetch: (phoneNumbers: string[]) => Promise<void>;
}

export default function useDataAPIGetContactMappingsByPhoneNumbers(
  phoneNumbers?: string[]
): Result {
  const client = useDataAPIClient();
  const [state, setState] = useState<State>({ isLoading: false });

  async function fetch(phoneNumbers: string[]): Promise<void> {
    setState({ isLoading: true });

    try {
      const data = await client.getContactMappingsByPhoneNumbers(phoneNumbers);

      setState({ isLoading: false, data });
    } catch (error: any) {
      setState({ isLoading: false, error });
    }
  }

  useEffect(() => {
    if (!phoneNumbers) return;

    fetch(phoneNumbers);
  }, [phoneNumbers]);

  return { ...state, refetch: fetch };
}
